import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';

import { addErrorMessageBody, toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { changeFormFieldValue, setNewForm } from 'apps/auth/actions/formAction';
import { getField } from 'apps/auth/components/form-multi/utils';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import ModalWithTimer from 'apps/auth/components/utils/ModalWithTimer';
import { LIST_SCREEN, PERIOD_SCREEN, SUCCESS_SCREEN } from 'apps/auth/constants/Constants';
import { END_DATE, START_DATE } from 'apps/auth/constants/fieldsName';
import { GA_ACTIVITY } from 'apps/auth/constants/formName';
import { apiFetchDataBlob } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

import ListScreen from './ListScreen';
import SelectPeriodScreen from './SelectPeriodScreen';

const AccountStatementMain = (props) => {
    const [screen, setScreen] = useState(LIST_SCREEN);
    const linkRef = useRef(null);
    const formName = GA_ACTIVITY;

    useEffect(() => {
        let fields = {};
        fields[START_DATE] = getField('start_date', '', '', true, false, props.startDatePlaceholder, 'date');
        fields[END_DATE] = getField('end_date', '', '', true, false, props.endDatePlaceholder, 'date');
        props.setNewForm(formName, fields);
        return () => {
            if (linkRef?.current?.href) {
                linkRef.current.remove();
                URL.revokeObjectURL(linkRef.current.href);
            }
        };
    }, []);

    const closeModal = () => {
        linkRef.current.click();
        setScreen(LIST_SCREEN);
    };

    const requestToServerStatement = ({ dateBegin, dateEnd }) => {
        props.toggleSpinner(true);
        apiFetchDataBlob(`${props.pdfUrl}/${props.idForUrl}/${dateBegin}/${dateEnd}`, props.addErrorMessageBody)
            .then((result) => {
                if (result && result instanceof Blob) {
                    linkRef.current.href = URL.createObjectURL(result);
                    props.toggleSpinner(false);
                    setScreen(SUCCESS_SCREEN);
                    props.changeFormFieldValue(formName, '', END_DATE);
                    props.changeFormFieldValue(formName, '', START_DATE);
                } else {
                    props.toggleSpinner(false);
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
            });
    };

    const renderComponent = () => {
        if (screen === LIST_SCREEN) {
            return (
                <ListScreen
                    setShowPeriod={() => {
                        setScreen(PERIOD_SCREEN);
                    }}
                    requestToServerStatement={requestToServerStatement}
                />
            );
        } else if (screen === PERIOD_SCREEN) {
            return <SelectPeriodScreen requestToServerStatement={requestToServerStatement} />;
        } else if (screen === SUCCESS_SCREEN) {
            return <ModalWithTimer text={props.statementCreated} onClick={closeModal} />;
        }
    };
    return (
        <ModalComponent
            isVerticalCentered={screen === SUCCESS_SCREEN}
            canCloseModal={screen === LIST_SCREEN || screen === PERIOD_SCREEN}
            onCloseIconClick={() => {
                if (screen === PERIOD_SCREEN) {
                    setScreen(LIST_SCREEN);
                } else {
                    props.toggleModal(false);
                }
            }}
        >
            <a target="_blank" ref={linkRef} />
            {renderComponent()}
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        startDatePlaceholder: state.messages.pageMessages.startDatePlaceholder,
        endDatePlaceholder: state.messages.pageMessages.endDatePlaceholder,
        statementCreated: state.messages.pageMessages.statementCreated,
    };
};
export default connect(mapStateToProps, {
    setNewForm,
    toggleModal,
    toggleSpinner,
    addErrorMessageBody,
    changeFormFieldValue,
})(AccountStatementMain);
